import Developers from '@/models/general/settings/Developers';

const getDefaultState = () => ({
  responses: [],
  mappers: [],
  mapper: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setResponses(state, payload) {
      state.responses = payload || [];
    },

    setMappers(state, payload) {
      state.mappers = payload || [];
    },

    setMapper(state, payload) {
      state.mapper = payload || {};
    },
  },

  actions: {
    async getAllResponses({ commit, getters, state }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Developers.getAllResponses();
        commit('setResponses', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async getEventMappers({ commit, getters, state }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Developers.getEventMappers();

        commit('setMappers', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
    async getEventMapper({ commit, state }, id) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Developers.getEventMapper(id);

        commit('setMapper', data.data);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async createEventMapper({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Developers.createEventMapper(body);

        commit('setMappers', [{ ...data.data }, ...state.mappers]);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async updateEventMapper({ commit, state }, { id, body }) {
      try {
        commit('setLoading', true, { root: true });
        let mappers = [...state.mappers];
        const { data } = await Developers.updateEventMapper(id, body);

        let stateWebhookIndex = mappers.findIndex((x) => x.mapper_id == id);

        mappers[stateWebhookIndex] = { ...data.data };
        commit('setMappers', mappers);

        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.log(ex);
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
